import axios from 'axios';

const updateProductSubtypes = async () => {
  try {
    const res = await axios.get('/subtypes_by_product_type', {
      params: { product_type_id: $('.product_type_select').val() },
    });
    const subtypes = res.data;
    const subtypeSelect = $('.product_subtype_select');
    $('.product_subtype_select option:not(:first)').remove();
    subtypes.forEach(subtype => {
      subtypeSelect.append(
        $('<option>', {
          text: subtype.name,
          value: subtype.id,
        })
      );
    });
    subtypeSelect.trigger('change');
  } catch (error) {
    console.log(error.response.data);
  }
};

const updateMeasurementUnits = async () => {
  try {
    const res = await axios.get('/measurement_units_by_group', {
      params: {
        measurement_unit_group_id: $('.measurement_unit_group_select').val(),
      },
    });
    const units = res.data;
    const unitSelect = $('.measurement_unit_select');
    $('.measurement_unit_select option:not(:first)').remove();
    units.forEach(unit => {
      unitSelect.append(
        $('<option>', {
          text: unit.name_and_description,
          value: unit.id,
        })
      );
    });
    unitSelect.trigger('change');
  } catch (error) {
    console.log(error.response.data);
  }
};

const updateProductTypeSelect = async () => {
  const url = $('#product_for_production').is(':checked')
    ? '/production_product_types'
    : '/all_product_types';

  try {
    const res = await axios.get(url);
    const productTypes = res.data;
    const productTypeSelect = $('.product_form_type_select');
    $('.product_form_type_select option:not(:first)').remove();
    productTypes.forEach(productType => {
      productTypeSelect.append(
        $('<option>', {
          text: productType.name,
          value: productType.id,
        })
      );
    });
    productTypeSelect.trigger('change');
  } catch (error) {
    console.log(error.response.data);
  }
};

const toggleMicroIngredientCheckbox = async () => {
  const productTypeName = $('.product_form_type_select option:selected').text();
  const isRawMaterial =
    productTypeName === 'Materia Prima' ||
    productTypeName === 'Producto Semielaborado';
  if (!isRawMaterial) {
    $('#product_is_micro_ingredient').prop('checked', false);
  }
  $('.micro_ingredient_checkbox').toggleClass('d-none', !isRawMaterial);
};

document.addEventListener('turbolinks:load', function () {
  $('.product_type_select').on('change', updateProductSubtypes);
  $('.measurement_unit_group_select').on('change', updateMeasurementUnits);
  $('.product_name_select').select2({
    placeholder: 'Buscar un producto por nombre...',
    minimumInputLength: 3,
    width: '100%',
  });
  toggleMicroIngredientCheckbox();
  $('.product_form_type_select').on('change', toggleMicroIngredientCheckbox);
  $('.product_measurement_unit_select').select2({
    placeholder: 'Buscar por nombre de unidad o grupo de unidades...',
    matcher(params, data) {
      const originalMatcher = $.fn.select2.defaults.defaults.matcher;
      const result = originalMatcher(params, data);
      if (
        result &&
        data.children &&
        result.children &&
        data.children.length !== result.children.length &&
        data.text.toLowerCase().includes(params.term)
      ) {
        result.children = data.children;
      }
      return result;
    },
  });
  if ($('#product_for_production').is(':checked')) {
    $('.product_measurement_unit_select')
      .find("option:contains('kg - Kilogramo')")
      .prop('selected', true)
      .trigger('change');
    $('.product_measurement_unit_select option:not(:selected)')
      .prop('disabled', true)
      .trigger('change');
  } else if (document.querySelector('.product_form_type_select')) {
    updateProductTypeSelect();
  }

  $('#product_for_production').on('click', function () {
    updateProductTypeSelect();
    if ($('#product_for_production').is(':checked')) {
      $('.product_measurement_unit_select')
        .find("option:contains('kg - Kilogramo')")
        .prop('selected', true)
        .trigger('change');
      $('.product_measurement_unit_select option:not(:selected)')
        .prop('disabled', true)
        .trigger('change');
    } else {
      $('.product_measurement_unit_select option:not(:selected)')
        .prop('disabled', false)
        .trigger('change');
      $('.product_measurement_unit_select')
        .find('option:first')
        .prop('selected', true)
        .trigger('change');
    }
  });
});
